import { Tooltip } from "./ToolTip";

type OptionButtonProps = {
  onClick: () => void;
  tooltipText: string;
};

const dotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
);

export const OptionButton = ({ onClick, tooltipText }: OptionButtonProps) => {
  return (
    <Tooltip text={tooltipText} position="left">
      <button
        type="button"
        onClick={onClick}
        className="bg-transparent border-none w-8 h-8 cursor-pointer p-0"
      >
        {dotsIcon}
      </button>
    </Tooltip>
  );
};